import { render } from "./card-border-blue.vue?vue&type=template&id=3fce7af1&scoped=true"
import script from "./card-border-blue.vue?vue&type=script&lang=js"
export * from "./card-border-blue.vue?vue&type=script&lang=js"

import "./card-border-blue.vue?vue&type=style&index=0&id=3fce7af1&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fce7af1"]])

export default __exports__